import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight
import {
    Face6, Password, CalendarMonth, Search, AddLocationAlt
} from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";
import { useGeolocation } from 'react-use';

const zimbabwePlaces = [
    { name: "Banket", lat: -17.3793, lng: 30.3954 },
    { name: "Beitbridge", lat: -22.2018, lng: 29.9915 },
    { name: "Bindura", lat: -17.30192, lng: 31.33056 },
    { name: "Bulawayo", lat: -20.15, lng: 28.58333 },
    { name: "Chegutu", lat: -18.13021, lng: 30.14074 },
    { name: "Chinhoyi", lat: -17.3622, lng: 30.1987 },
    { name: "Chiredzi", lat: -21.05, lng: 31.66667 },
    { name: "Chitungwiza", lat: -18.01274, lng: 31.07555 },
    { name: "Chivhu", lat: -19.0179, lng: 30.8975 },
    { name: "Concession", lat: -17.27, lng: 30.56 },
    { name: "Gokwe", lat: -18.20476, lng: 28.9349 },
    { name: "Guruve", lat: -16.4500, lng: 30.9000 },
    { name: "Gwanda", lat: -20.93889, lng: 29.01861 },
    { name: "Gweru", lat: -19.4657, lng: 29.8124 },
    { name: "Harare", lat: -17.82772, lng: 31.05337 },
    { name: "Hwange", lat: -18.36446, lng: 26.49877 },
    { name: "Kadoma", lat: -18.33328, lng: 29.91534 },
    { name: "Kariba", lat: -16.5166, lng: 28.8489 },
    { name: "Kwekwe", lat: -18.92809, lng: 29.81486 },
    { name: "Marondera", lat: -18.18527, lng: 31.55193 },
    { name: "Masvingo", lat: -20.06373, lng: 30.82766 },
    { name: "Mt Darwin", lat: -16.7667, lng: 31.5667 },
    { name: "Mvurwi", lat: -17.0278, lng: 30.8556 },
    { name: "Mutare", lat: -18.9707, lng: 32.67086 },
    { name: "Mutoko", lat: -17.39699, lng: 32.22677 },
    { name: "Muzarabani", lat: -16.0833, lng: 31.6333 },
    { name: "Norton", lat: -17.8765, lng: 30.6742 },
    { name: "Nyanga", lat: -18.53333, lng: 32.76667 },
    { name: "Plumtree", lat: -20.47806, lng: 27.79722 },
    { name: "Redcliff", lat: -19.03333, lng: 29.78333 },
    { name: "Ruwa", lat: -17.88972, lng: 31.24472 },
    { name: "Rusape", lat: -18.52785, lng: 32.12843 },
    { name: "Shamva", lat: -17.2980, lng: 31.5653 },
    { name: "Shurugwi", lat: -19.6771, lng: 29.9769 },
    { name: "Victoria Falls", lat: -17.93285, lng: 25.83066 },
    { name: "Zvishavane", lat: -20.32674, lng: 30.06648 },
    { name: "Other", lat: null, lng: null }
];


const FillProfile = () => {
    const [display_name, setDisplay_name] = useState("");
    const [gender, setGender] = useState("");
    const [relation_type, setRelation_type] = useState("");
    const [birthdate, setBirthdate] = useState("");
    const [bio, setBio] = useState("");
    const [place, setPlace] = useState("");
    const [job_title, setJob_title] = useState("");
    const [education, setEducation] = useState("");
    const [location_lat, setLocation_lat] = useState("");
    const [location_lng, setLocation_lng] = useState("");
    const [posting, setPosting] = useState(false);
    const state = useGeolocation();

    const [location, setLocation] = useState({ lat: null, lng: null });
    const [error, setError] = useState(null);

    const navigate = useNavigate();

    const handleProceed = async () => {
        if (gender === "") {
            toast.warn("Failed. Select your gender", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (place === "") {
            toast.warn("Failed. Select place you stay", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (relation_type === "") {
            toast.warn("Failed. Select relationship type you are looking for", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (birthdate === "") {
            toast.warn("Failed. Select your date of birth first", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }
        if (bio === "") {
            toast.warn("Failed. Type in your Bio first", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }

        setPosting(true);

        const userData = await JSON.parse(localStorage.getItem("userSessionData"));
        const token = userData.token;

        const dataObj = {
            display_name,
            gender,
            relation_type,
            birthdate,
            bio,
            job_title,
            education,
            place,
            location_lat,
            location_lng
        }

        console.log(dataObj);

        const baseUrl = apilink.link;
        await axios
            .post(`${baseUrl}/profile`, dataObj, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            })

            .then((response) => {
                setPosting(false);
                console.log(response.data)
                if (response.data.message === "Profile saved") {
                    // 1️⃣ Get the stored user object
                    const userDataRaw = localStorage.getItem("userSessionData"); // or sessionStorage.getItem(...)
                    if (!userDataRaw) return; // nothing stored yet

                    const userData = JSON.parse(userDataRaw);

                    // 2️⃣ Update multiple profile fields at once
                    userData.profile = {
                        ...userData.profile,
                        display_name: display_name, 
                        gender: gender,
                        relation_type: relation_type,
                        birthdate: birthdate,
                        bio: bio,
                        job_title: job_title,
                        education: education,
                        place: place,
                        location_lat: location_lat,
                        location_lng: location_lng
                    };

                    // 3️⃣ Save it back to localStorage
                    localStorage.setItem("userSessionData", JSON.stringify(userData));

                    toast.success("Saving successfull. Lets move to the next step", {
                        position: "top-center",
                        hideProgressBar: true,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        onClose: () => {
                            navigate("/preferences");
                        },
                        theme: "light",
                    });
                }
            })
            .catch((error) => {
                setPosting(false);
                console.log(error);
                console.log(error.response.data.message);
            });
    };

    const handleMemberSignIn = () => {
        navigate("/");
    };

    const handlePlaceChange = (e) => {
        const selected = e.target.value;
        setPlace(selected);

        const loc = zimbabwePlaces.find(p => p.name === selected);
        if (loc) {
            setLocation_lat(loc.lat);
            setLocation_lng(loc.lng);
        } else {
            setLocation_lat(null);
            setLocation_lng(null);
        }
    };


    // useEffect(() => {
    //     const getAsyncData = async () => {
    //         const regData = await JSON.parse(
    //             localStorage.getItem("userReg")
    //         );
    //         console.log("code: " + regData.identifier);
    //         setIdentifier(regData.identifier);
    //         setType(regData.id_type);
    //     };
    //     getAsyncData();
    // }, []);

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocation({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    });
                },
                (err) => {
                    setError(err.message);
                }
            );
        } else {
            setError('Geolocation not supported.');
        }
    }, []);

    //     useEffect(() => {
    //     if ("geolocation" in navigator) {
    //       navigator.geolocation.getCurrentPosition(
    //         (position) => {
    //           setLocation({
    //             lat: position.coords.latitude,
    //             lng: position.coords.longitude,
    //           });
    //         },
    //         (err) => {
    //           setError(err.message); // e.g., "User denied Geolocation"
    //         },
    //         {
    //           enableHighAccuracy: true,
    //           timeout: 10000,   // 10 seconds
    //           maximumAge: 0,
    //         }
    //       );
    //     } else {
    //       setError("Geolocation not supported by this browser.");
    //     }
    //   }, []);

    // return { location, error };


    return (
        <>
            <div
                style={{
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "56px",
                    paddingInline: 30,
                }}
            >
                <img
                    alt="logo"
                    style={{ width: "100px", height: "80px", resizeMode: "stretch" }}
                    src={require("./logo.png")}
                />
                <h1
                    className="navbar-brand mb-0"
                    style={{ fontFamily: "Caveat", fontSize: 38 }}
                >
                    <b>Collide - </b> Dating
                </h1>
                <div>
                    {state.error && <p>Error: {state.error.message}</p>}
                    {state.latitude && state.longitude ? (
                        <p>
                            Latitude: {state.latitude}, Longitude: {state.longitude}
                        </p>
                    ) : (
                        <p>Fetching location...</p>
                    )}
                </div>
                <p
                    style={{
                        color: "#010832",
                        fontFamily: "Open Sans",
                        marginTop: "30px",
                    }}
                >
                    Finish setting up your profile
                </p>
                <p
                    style={{
                        color: "#00000098",
                        fontFamily: "Open Sans",
                        marginTop: "10px",
                        fontSize: "12px",
                        textAlign: "center"
                    }}
                >
                    We need a few more details to personalize <br />  your experience. Once you’re done, <br /> you can start swiping right away!
                </p>

                <div
                    style={{
                        width: "320px",
                        marginBottom: "1px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                    }}
                >
                    <label style={{ fontSize: '12px', color: "#010832" }}>
                        What is your preferred display name? (Optional)
                        {/* What is {state.latitude}(Optional) */}
                    </label>
                </div>

                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Face6 style={{ color: "#ffffff" }} />
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <input
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',

                            }}
                            value={display_name}
                            onChange={(e) => { setDisplay_name(e.target.value) }}
                        />
                    </div>
                    <div></div>
                </div>

                <div
                    style={{
                        width: "320px",
                        marginBottom: "1px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                    }}
                >
                    <label style={{ fontSize: '12px', color: "#010832" }}>
                        What is your gender?
                    </label>
                </div>
                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Face6 style={{ color: "#ffffff" }} />
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <select
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',
                            }}
                            value={gender}                 // <-- controlled value
                            onChange={(e) => setGender(e.target.value)}
                        >
                            <option value="" disabled>
                                Select gender
                            </option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="non_binary">Non Binary</option>
                            <option value="other">Other</option>
                        </select>

                    </div>
                    <div></div>
                </div>
           
                <div
                    style={{
                        width: "320px",
                        marginBottom: "1px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                    }}
                >
                    <label style={{ fontSize: '12px', color: "#010832" }}>
                        What is the relationship type are you looking for?
                    </label>
                </div>

                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Search style={{ color: "#ffffff" }} />
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <select
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',
                            }}
                            value={relation_type}                   // controlled value
                            onChange={(e) => setRelation_type(e.target.value)}
                        >
                            <option value="" disabled>
                                Select relationship type
                            </option>
                            <option value="Serious relationship">Serious relationship</option>
                            <option value="Short-term relationship">Short-term relationship</option>
                            <option value="Friendship">Friendship</option>
                            <option value="Meeting new people">Meeting new people</option>
                            <option value="Someone to hang out with">Someone to hang out with</option>
                            <option value="Still figuring it out">Still figuring it out</option>
                        </select>

                    </div>
                    <div></div>
                </div>

                <div
                    style={{
                        width: "320px",
                        marginBottom: "1px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                    }}
                >
                    <label style={{ fontSize: '12px', color: "#010832" }}>
                        What is your current location?
                    </label>
                </div>

                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <AddLocationAlt style={{ color: "#ffffff" }} />
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <select
                            value={place}
                            onChange={handlePlaceChange}
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',
                            }}
                        >
                            <option value="" disabled>Select location</option>
                            {zimbabwePlaces.map((loc) => (
                                <option key={loc.name} value={loc.name}>
                                    {loc.name}
                                </option>
                            ))}
                        </select>

                    </div>
                    <div></div>
                </div>

                <div
                    style={{
                        width: "320px",
                        marginBottom: "1px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                    }}
                >
                    <label style={{ fontSize: '12px', color: "#010832" }}>
                        Whats your date of birth?
                    </label>
                </div>

                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <CalendarMonth style={{ color: "#ffffff" }} />
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <input
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',

                            }}
                            value={birthdate}
                            placeholder="Date of birth"
                            type="date"
                            onChange={(e) => { setBirthdate(e.target.value) }}
                        />
                    </div>
                    <div></div>
                </div>
                <div
                    style={{
                        width: "320px",
                        marginBottom: "1px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                    }}
                >
                    <label style={{ fontSize: '12px', color: "#010832" }}>
                        Tell us a little bit about yourself (Bio)
                    </label>
                </div>

                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 106,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 106,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Face6 style={{ color: "#ffffff" }} />
                    </div>
                    <div style={{
                        height: 103,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <textarea
                            style={{
                                height: 105.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',

                            }}
                            value={bio}
                            rows={4}
                            onChange={(e) => { setBio(e.target.value) }}
                        />
                    </div>
                    <div></div>
                </div>
                <div
                    style={{
                        width: "320px",
                        marginBottom: "1px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                    }}
                >
                    <label style={{ fontSize: '12px', color: "#010832" }}>
                        Whats your education level? (Optional)
                    </label>
                </div>
                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Face6 style={{ color: "#ffffff" }} />
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <select
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',
                            }}
                            value={education}                       // controlled value
                            onChange={(e) => setEducation(e.target.value)}
                        >
                            <option value="" disabled>
                                Select education
                            </option>
                            <option value="High School">High School</option>
                            <option value="Certificate">Certificate</option>
                            <option value="Diploma">Diploma</option>
                            <option value="Higher Diploma">Higher Diploma</option>
                            <option value="Degree">Degree</option>
                            <option value="Masters">Masters</option>
                            <option value="Doctrate">Doctrate</option>
                        </select>

                    </div>
                    <div></div>
                </div>

                <div
                    style={{
                        width: "320px",
                        marginBottom: "1px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                    }}
                >
                    <label style={{ fontSize: '12px', color: "#010832" }}>
                        What is your job title? (Optional)
                    </label>
                </div>

                <div
                    style={{
                        width: "320px",
                        borderWidth: 1,
                        borderColor: "#010832",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        height: 53,
                        marginBottom: "10px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                    }}
                >
                    <div style={{
                        width: "60px",
                        height: 53,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Face6 style={{ color: "#ffffff" }} />
                    </div>
                    <div style={{
                        height: 50,
                        display: "flex",
                        width: "260px",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}>
                        <input
                            style={{
                                height: 51.2,
                                marginTop: 3,
                                width: "259px",
                                fontFamily: "Open Sans",
                                fontSize: 14,
                                paddingInline: 10,
                                border: "1px solid white",
                                borderTopRightRadius: 5,
                                borderBottomRightRadius: 5,
                                outlineStyle: 'none',

                            }}
                            value={job_title}
                            onChange={(e) => { setJob_title(e.target.value) }}
                        />
                    </div>
                    <div></div>
                </div>


                <button
                    onClick={() => handleProceed()}
                    style={{
                        width: "320px",
                        backgroundColor: "#010832",
                        borderRadius: 5,
                        border: "none",
                        height: 50,
                        fontFamily: "Open Sans",
                        fontSize: 14,
                        marginBottom: 25,
                        color: "white",
                        marginTop: "10px",
                    }}
                >
                    {posting === false && <>Save</>}
                    {posting && (
                        <>
                            <Squares />
                        </>
                    )}
                </button>

                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </div>
        </>
    );
};

export default FillProfile;
